export enum NotificationDeliveryOption {
  INSTANT = 'instant',
  HOURLY = 'hourly',
  DAILY = 'daily',
}

export interface NotificationDeliveryDto {
  user_id: string;
  delivery_option: NotificationDeliveryOption;
  created_at: string;
  updated_at: string;
}

export interface NotificationDelivery {
  userId: string;
  deliveryOption: NotificationDeliveryOption;
  createdAt: string;
  updatedAt: string;
}
